module.exports = __webpack_public_path__ + "static/media/Stellar Vox King Headboard - 180 cm_Cream.7ca00e0a.png";